import { createContext, useState, useEffect, useContext } from 'react';

import { getUserData } from '../api/apiService';

const ApiContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [userName, setUserName] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await getUserData();
                console.log('User data:', data);
                setUserName(data.username);
                setIsAuthenticated(true);
                setIsAdmin(data.isAdmin === true);
            } catch (error) {
                console.error('Error loading user data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadData();
    }, []);

    const value = {
        userName,
        isLoading,
        isAuthenticated,
        isAdmin,
    };

    return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(ApiContext);
    if (context === null) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};